import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfileRouting } from './profile.routing';
import { ContactService, ReferrerHttpService, UserGamesHttpService, UserService } from '@profile/infra';
import { RankService } from '@rank/infra';
import { UpdateService } from '@update/infra';
import { PenaltiesService, UserCommentsService } from '@fair-play/infra';

@NgModule({
  imports: [RouterModule.forChild(ProfileRouting)],
  providers: [
    UserService,
    ReferrerHttpService,
    ContactService,
    RankService,
    UpdateService,
    UserGamesHttpService,
    PenaltiesService,
    UserCommentsService
  ]
})
export class ProfileModule {}
